import Vue from 'vue';

import VBlackerTheme, { VBlackerThemeProvider } from 'v-blacker-theme';

import { createRouter } from '@router';

import store from '@store';

import VCharts from 'v-charts';

import PbOuterLink from '@components/outerLink';
import PbDateTime from '@components/PbDateTime.vue';
import PbColoredStateBadge from '@components/coloredStateBadge';

import App from './App.vue';

import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.use(VBlackerTheme);
Vue.use(VCharts);

Vue.component('pb-date-time', PbDateTime);
Vue.component('pb-outer-link', PbOuterLink);
Vue.component('pb-colored-state-badge', PbColoredStateBadge);

const router = createRouter();

const app = new Vue({
  store,
  router,
  ...VBlackerThemeProvider,
  render: h => h(App),
});

router.onReady(() => app.$mount('#app'));
